// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";


import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
Vue.use(ElementUI) //使用elementUI

// 使用aos动画
import AOS from 'aos'
import 'aos/dist/aos.css'
/* aos动画初始化 */
AOS.init();

import AudioPlayer from '@liripeng/vue-audio-player'
Vue.use(AudioPlayer)

import baiduMap from 'vue-baidu-map-v3';

Vue.use(baiduMap, {
    ak: 'H9a7GaGk6Qjr8GIfYSmXLrVmRYiAwoQK'
});

import './assets/css/common.css'
//import "slick-carousel/slick/slick.css"
import {parseTime} from "@/utils/datetimeUtil"

// 全局方法挂载
Vue.prototype.parseTime = parseTime

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

var _hmt = _hmt || [];
window._hmt = _hmt;
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0ff665bbb9624d06e43e9e3fc642d9b1";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
  if (_hmt) {
      if (to.path) {
          _hmt.push(['_trackPageview', '/#' + to.fullPath]);
      }
  }
  next();
});


// WEBPACK FOOTER //
// ./src/main.js